import { SiteTypes } from '../enums';
import { getEndpointURL } from './getEndpointUrl';

export const goToFavourites = () => {
  window.location.href = getEndpointURL(SiteTypes.FAVOURITES);
};
